// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2aeuH","header":"Messages_header__2jibl"};